import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap";

const hotelData = {
  "Zona 15": {
    description: "hotels_zone_15",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    shadow: "rgba(102, 126, 234, 0.3)",
    hotels: [
      {
        image: "/assets/images/hotels/achotels.jpg",
        title: "AC Hotel Guatemala City",
        address: "Ciudad Cayalá, Edificio B1 11 Avenida 35-02, Zona 16",
        link: "https://www.marriott.com/es/hotels/guaar-ac-hotel-guatemala-city/overview/",
        approximateCost: "$143",
        estimatedTime: "5-10 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/vistaquince.jpg",
        title: "Hotel Vista Quince",
        address: "Ruta 1 4-48, Zona 15",
        link: "https://www.vistaquince.com/",
        approximateCost: "$140",
        estimatedTime: "5-10 min",
        includesBreakfast: false,
      },
    ],
  },
  "Zona 10": {
    description: "hotels_zone_10",
    gradient: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
    shadow: "rgba(17, 153, 142, 0.3)",
    hotels: [
      {
        image: "/assets/images/hotels/intercontinental.jpg",
        title: "Real Intercontinental Guatemala",
        address: "14 Calle 2-51, Zona 10",
        link: "https://www.ihg.com/intercontinental/hotels/es/es/guatemala-city/guaha/hoteldetail",
        approximateCost: "$214",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/westin.jpg",
        title: "The Westin Camino Real",
        address: "14 Calle 0-20, Zona 10",
        link: "https://www.marriott.com/es/hotels/guawi-the-westin-camino-real-guatemala/overview/",
        approximateCost: "$143",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/hyatt.jpg",
        title: "Hyatt Centric Guatemala City",
        address: "12 Calle 2-25, Zona 10",
        link: "https://www.hyatt.com/hyatt-centric/es-ES/guact-hyatt-centric-guatemala-city",
        approximateCost: "$211",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/clarion.jpg",
        title: "Clarion Hotel & Suites",
        address: "14 Calle 3-08, Zona 10",
        link: "https://clarionguatemala.com/",
        approximateCost: "$128",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/holidayinn.jpg",
        title: "Holiday Inn Guatemala",
        address: "1 Avenida 13-22, Zona 10",
        link: "https://www.ihg.com/holidayinn/hotels/es/es/ciudad-de-guatemala/guact/hoteldetail",
        approximateCost: "$100",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/wydham.jpg",
        title: "Wyndham Garden Guatemala City",
        address: "1 Avenida 12-46, Zona 10",
        link: "https://www.wyndhamhotels.com/es-xl/wyndham-garden/guatemala-guatemala/wyndham-garden-guatemala-city/overview",
        approximateCost: "$133",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/fontabella.jpg",
        title: "H&F Hotel Fontabella",
        address: "13 Calle 4-29, Zona 10",
        link: "https://hotelfontabella.com/",
        approximateCost: "$115",
        estimatedTime: "10-15 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/bestwestern.jpg",
        title: "Best Western Plus Hotel Stofella",
        address: "2 Avenida 12-28, Zona 10",
        link: "https://stofella.com/",
        approximateCost: "$95",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/veranda.jpg",
        title: "Hotel Casa Veranda",
        address: "12 Calle 1-24, Zona 10",
        link: "https://www.hotelcasaveranda.com/",
        approximateCost: "$129",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/meraki.jpg",
        title: "Meraki Boutique Hotel",
        address: "13 Calle 3-57, Zona 10",
        link: "https://www.booking.com/hotel/gt/meraki-boutique.es.html",
        approximateCost: "$84",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/ciudadvieja.jpg",
        title: "Hotel Ciudad Vieja",
        address: "8 Calle 3-67, Zona 10",
        link: "https://hotelciudadvieja.com/",
        approximateCost: "$70",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/quetzalroo.jpg",
        title: "Quetzalroo Hostel",
        address: "6A Avenida 784, Cdad. de Guatemala 01010",
        link: "http://www.quetzalroo.com/",
        approximateCost: "$10",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/central10.jpg",
        title: "Central 10 Boutique Hostel",
        address: "6 Avenida 14-49, Zona 10",
        link: "https://www.booking.com/hotel/gt/central-hostel-ciudad-de-guatemala.html",
        approximateCost: "$10",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
      {
        image: "/assets/images/hotels/centralhostel.jpg",
        title: "Central Hostel Reforma",
        address: "14 Calle 0-61, Zona 10",
        link: "https://www.booking.com/hotel/gt/central-hostel-reforma.html",
        approximateCost: "$16",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
    ],
  },
  "Zona 9": {
    description: "hotels_zone_9",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    shadow: "rgba(245, 87, 108, 0.3)",
    hotels: [
      {
        image: "/assets/images/hotels/hilton.jpg",
        title: "Hilton Garden Inn",
        address: "13 Calle 7-65, Zona 9",
        link: "https://www.hilton.com/es/hotels/guagcgi-hilton-garden-inn-guatemala-city/",
        approximateCost: "$104",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/barcelo.jpg",
        title: "Barceló Guatemala City",
        address: "7 Avenida 15-45, Zona 9",
        link: "https://www.barcelo.com/es-us/barcelo-guatemala-city/",
        approximateCost: "$87",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/villaespañola.jpg",
        title: "Hotel Villa Española",
        address: "2 Calle 7-51, Zona 9",
        link: "https://www.hotelvillaespanola.com/",
        approximateCost: "$90",
        estimatedTime: "15-20 min",
        includesBreakfast: true,
      },
    ],
  },
  "Zona 4": {
    description: "hotels_zone_4",
    gradient: "linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)",
    shadow: "rgba(252, 74, 26, 0.25)",
    hotels: [
      {
        image: "/assets/images/hotels/conquistador.jpg",
        title: "Conquistador Hotel & Conference Center",
        address: "Vía 5 4-68, Zona 4",
        link: "https://www.booking.com/hotel/gt/conquistador-amp-conference-center.html",
        approximateCost: "$111",
        estimatedTime: "20-25 min",
        includesBreakfast: false,
      },
      {
        image: "/assets/images/hotels/goodhotel.jpg",
        title: "Good Hotel Guatemala City",
        address: "Ruta 4 6-32, Zona 4",
        link: "https://goodhotel.co/guatemala-city",
        approximateCost: "$99",
        estimatedTime: "15-20 min",
        includesBreakfast: false,
      },
    ],
  },
};

export const HotelsContent = () => {
  const { t } = useTranslation();

  return (
    <div style={{ paddingTop: "60px", paddingBottom: "60px", backgroundColor: "#f8f9fa" }}>
      <Container>
        {/* Título */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ color: "#333333", fontWeight: "bold", marginBottom: "1rem" }}>
              {t("hotels_title")}
            </h1>
            <p className="text-center lead" style={{ color: "#666666" }}>
              {t("hotels_lead")}
            </p>
          </Col>
        </Row>

        {/* Intro */}
        <Row className="mb-5">
          <Col md={{ size: 10, offset: 1 }}>
            <p style={{ color: "#555", lineHeight: "1.8", textAlign: "center", fontSize: "1.1rem" }}>
              {t("hotels_intro")}
            </p>
            <p style={{ color: "#555", lineHeight: "1.8", textAlign: "center", fontSize: "1.1rem" }}>
              {t("hotels_zones_info")}
            </p>
          </Col>
        </Row>

        {/* Hoteles por zona */}
        {Object.entries(hotelData).map(([zone, zoneData]) => (
          <div key={zone} className="mb-5">
            {/* Zone header */}
            <div className="text-center mb-4">
              <span style={{
                display: "inline-block",
                padding: "0.5rem 2rem",
                borderRadius: "25px",
                background: zoneData.gradient,
                color: "white",
                fontWeight: "700",
                fontSize: "1.1rem",
                boxShadow: `0 4px 15px ${zoneData.shadow}`,
              }}>
                📍 {zone}
              </span>
              <p className="mt-2" style={{ color: "#777", fontSize: "0.9rem" }}>
                {t(zoneData.description)}
              </p>
            </div>

            {/* Hotel cards */}
            <Row className="justify-content-center">
              {zoneData.hotels.map((hotel, idx) => (
                <Col sm="6" md="4" lg="3" key={idx} className="mb-4">
                  <div style={{
                    background: "white",
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.3s ease",
                  }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.08)";
                    }}
                  >
                    <img
                      src={hotel.image}
                      alt={hotel.title}
                      style={{ width: "100%", height: "160px", objectFit: "cover" }}
                      loading="lazy"
                    />
                    <div style={{ padding: "1.2rem", flex: 1, display: "flex", flexDirection: "column" }}>
                      <h6 style={{ fontWeight: "bold", color: "#333", marginBottom: "0.5rem", minHeight: "2.8rem", display: "flex", alignItems: "flex-start" }}>
                        {hotel.title}
                      </h6>
                      <p style={{ fontSize: "0.8rem", color: "#888", marginBottom: "0.5rem", minHeight: "3.2rem" }}>
                        {hotel.address}
                      </p>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
                        <span style={{ fontWeight: "bold", color: "#11998e", fontSize: "1.1rem" }}>
                          {t("hotels_from")} {hotel.approximateCost}
                        </span>
                        <span style={{ fontSize: "0.75rem", color: "#888" }}>
                          🚗 {hotel.estimatedTime}
                        </span>
                      </div>
                      {hotel.includesBreakfast && (
                        <span style={{
                          display: "inline-block",
                          padding: "0.2rem 0.6rem",
                          borderRadius: "10px",
                          background: "#e8f5e9",
                          color: "#2e7d32",
                          fontSize: "0.7rem",
                          fontWeight: "600",
                          marginBottom: "0.8rem",
                          alignSelf: "flex-start",
                        }}>
                          ☕ {t("hotels_breakfast")}
                        </span>
                      )}
                      <a
                        href={hotel.link}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm mt-auto"
                        style={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white",
                          fontWeight: "600",
                          borderRadius: "8px",
                          border: "none",
                          fontSize: "0.85rem",
                        }}
                      >
                        {t("hotels_book")}
                      </a>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ))}

        {/* Nota Airbnb */}
        <Row className="mt-3">
          <Col md={{ size: 8, offset: 2 }}>
            <div className="text-center p-4" style={{
              background: "white",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
            }}>
              <p style={{ color: "#555", marginBottom: 0, lineHeight: "1.8" }}>
                💡 {t("hotels_airbnb")}
              </p>
            </div>
          </Col>
        </Row>

      </Container>
    </div>
  );
};